import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { feedbackApi, queryClient } from '~/lib/request';
import { SubmitFeedbackPayload } from './types';

export function useSubmitFeedback() {
  return useMutation<unknown, Error, SubmitFeedbackPayload>({
    mutationFn: async (payload) => {
      const body = new FormData();
      body.append('application_id', payload.application_id);
      body.append('type', payload.type);
      body.append('text', payload.text);

      if (payload.attachments?.length) {
        payload.attachments.forEach((blob, i) => {
          const file = new File([blob], `attachment-${i + 1}.jpg`, {
            type: blob.type,
          });
          body.append('attachments', file);
        });
      }

      await feedbackApi.post('api/feedback/submit', {
        body,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['feedbacks'] });
      toast.success('Feedback submitted successfully!');
    },
  });
}
